import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    button: {
        width: Platform.select({
            default: widthPercentageToDP(328, 170),
            web: 200,
        }),
    },
    buttonText: {
        color: COLOR.background,
    },
    modalContainer: {
        marginBottom: androidScreenMarginBottom,
    },
});

export default styles;
